import type { DashboardKpi, DashboardAlert, ModuleStatus, DashboardWidget } from '../model/dashboardSchema';

/**
 * GET /api/dashboard/kpis
 *
 * Бэкенд: label, value (число или строка), sub (подзаголовок).
 * variant НЕ приходит — фронт определяет цвет по бизнес-правилам.
 */
export const dashboardKpis: DashboardKpi[] = [
  { label: 'Просроченные медосмотры', value: 3, sub: 'требуют действий' },
  { label: 'Истекает обучение (30 дн.)', value: 12, sub: 'в течение месяца' },
  // { label: 'Карты СОУТ актуальны', value: '94%', sub: '87 из 92 рабочих мест' },
  { label: 'Мероприятия по ОПР', value: 28, sub: 'в работе' },
];

/**
 * GET /api/dashboard/alerts
 *
 * Бэкенд: type (err/warn/ok/info), message (текст).
 * Даты в тексте message — бэкенд форматирует для отображения.
 */
export const dashboardAlerts: DashboardAlert[] = [
  {
    type: 'err',
    message: 'Медосмотр просрочен: Захаров А.А., Инженер по эксплуатации оборудования, Бригада №1',
    linkTo: '/medical/employee/ae62b6c0-f20b-47b3-afdb-82afd4296a12',
  },
  {
    type: 'err',
    message: 'Медосмотр просрочен: Михайлов И.Ю., Уборщик производственных помещений, Бригада №1',
    linkTo: '/medical/employee/522faae7-fd81-43ee-8572-b460b658575b',
  },
  {
    type: 'err',
    message: 'Обучение просрочено: Алексеев А.А., Газорезчик, Бригада №1',
    linkTo: '/training/employee/7956b62a-07b2-475e-8289-266cdd197213',
  },
  {
    type: 'err',
    message: 'Обучение просрочено: Алексеев В.Ю., Инженер по автоматизации прокатного стана, Бригада №1',
    linkTo: '/training/employee/39bbf5b3-1771-45f3-985e-7461da9995af',
  },
  // { type: 'warn', message: 'Карта СОУТ: Рабочее место №47 — пересмотр до 01.06.2026' },
];

/** GET /api/dashboard/modules — статус модулей. Бэкенд: module, total, overdue, expiring, status. */
export const moduleStatuses: ModuleStatus[] = [
  { module: 'Медосмотры', total: 312, overdue: 3, expiring: 11, status: 'warn' },
  { module: 'Обучение', total: 486, overdue: 0, expiring: 12, status: 'warn' },
  // { module: 'СОУТ', total: 92, overdue: 5, expiring: 8, status: 'warn' },
  { module: 'Оценка рисков', total: 67, overdue: 0, expiring: 4, status: 'ok' },
  { module: 'Нормы СИЗ', total: 243, overdue: 0, expiring: 0, status: 'ok' },
  { module: 'НПА и документы', total: 48, overdue: 2, expiring: 3, status: 'warn' },
];

/** GET /api/dashboard/widgets — крупные виджеты по доменам для главного экрана. */
export const dashboardWidgets: DashboardWidget[] = [
  {
    domain: 'medical',
    title: 'Медосмотры',
    linkTo: '/medical?tab=employees',
    status: 'err',
    metricsHint: 'Показатели по сотрудникам',
    metrics: [
      { label: 'Всего в контингенте', value: 312 },
      { label: 'Просрочено', value: 3, severity: 'err' },
      { label: 'Истекает (30 дн.)', value: 11, severity: 'warn' },
      { label: 'Не допущены', value: 2, severity: 'err' },
    ],
    problems: [
      'Петров А.В. — просрочен с 15.03.2026',
      'Кузнецов Р.Н. — просрочен с 20.03.2026',
      'Иванов С.Д. — просрочен с 10.04.2026',
    ],
  },
  {
    domain: 'training',
    title: 'Обучение и инструктажи',
    linkTo: '/training?tab=records',
    status: 'warn',
    metricsHint: 'Показатели по сотрудникам',
    metrics: [
      { label: 'Всего с назначениями', value: 486 },
      { label: 'Просрочено', value: 0 },
      { label: 'Истекает (30 дн.)', value: 12, severity: 'warn' },
      { label: 'Не допущены', value: 1, severity: 'warn' },
    ],
    problems: ['Волков Д.Н. — повторный инструктаж просрочен', 'Герасимов П.А. — электробезопасность истекла'],
  },
  // {
  //   domain: 'sout',
  //   title: 'СОУТ и рабочие места',
  //   linkTo: '/sout',
  //   status: 'warn',
  //   metrics: [
  //     { label: 'Всего рабочих мест', value: 92 },
  //     { label: 'Карт актуально', value: 87 },
  //     { label: 'Требуют пересмотра', value: 5, severity: 'warn' },
  //     { label: 'Просрочены', value: 0 },
  //   ],
  //   problems: ['РМ №47 — пересмотр до 01.06.2026'],
  // },
];
